'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import { FC, useEffect } from 'react';
import aaaTracking from 'modules/aaa_services/AAA_dataservice';
import { CLIENT_GTM_ID } from 'src/envVariables';

/** needed for connection internal tracking. See modules/aaa_services/tracking*/
export const GTM: FC = () => {
  useEffect(() => {
    aaaTracking.init();
  }, []);

  if (!CLIENT_GTM_ID) {
    console.error('NEXT_PUBLIC_GTM_ID is not defined');
    return null;
  }
  return (
    <GoogleTagManager
      dataLayer={typeof window !== 'undefined' ? window.aaaaaaa : {}}
      gtmId={CLIENT_GTM_ID}
    />
  );
};
